import React, { useEffect } from "react";
import Layout from "../components/Layout";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { useAuth } from "../hooks/useAuth";
import SignupForm from "../components/Signup";

const Signup = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate("/");
    }
  }, [user, navigate]);

  return (
    <Layout>
      <Box sx={{ padding: 4 }}>
        <SignupForm />
      </Box>
    </Layout>
  );
};

export default Signup;
